export default "__VITE_ASSET__Z5r952zV__"